import type { FC } from 'react'
import React from 'react'
import { Icon } from '@frontend/pole-ui/lib/components/Icon'
import { QuestFillIcon } from '@frontend/pole-ui/lib/components/Icon/svg/QuestFillIcon'
import { BubblingTooltip } from '@/components/ui'
import type { ILoanProductTooltipProps } from './types'
import './styles.scss'

export const LoanProductTooltip: FC<ILoanProductTooltipProps> = ({ text }) => {
  return (
    <BubblingTooltip content={text} tooltipProps={{ className: 'loanProductTooltip__text', placement: 'top-start', allowHTML: true }}>
      <div className="loanProductTooltip__content">
        <Icon component={<QuestFillIcon />} className="loanProductTooltip__icon" />
      </div>
    </BubblingTooltip>
  )
}
